//@ts-check
import React from 'react';
import { CustomContainer } from '../general';

/** @type {React.FC<{children:React.ReactNode, className?: string}>} */
export const MultiLabContainer = ({ children, className = '' }) => {
  return (
    <CustomContainer
      size="ensino-institucional"
      alignCenter={true}
      className={`flex flex-wrap gap-6 lg:!mr-0 lg:!gap-x-3 xl:!gap-x-6 lg:!w-[840px] xl:!w-[1167px] 2xl:!w-[1508px] ${className}`}
    >
      {children}
    </CustomContainer>
  );
};